module.exports = __webpack_public_path__ + "media/flags/ss-776cc05a.svg";